import { getAuthTokenAsync } from "src/store/common";
import { Notification, Meta } from "src/store/types";
import * as api from "./api";

export interface NotificationApiResponse {
  data: Notification[];
  meta: Meta;
}

export interface UnreadCountResponse {
  data: {
    unreadNotificationCount: number;
  };
}

// Fetch notification list
export const fetchNotificationList = async (data: {
  page: number;
  limit: number;
}): Promise<NotificationApiResponse> => {
  const params = {
    page: data.page,
    limit: data.limit,
  };

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/notification`,
    params,
  );
  return response;
};

// Get unread notification count
export const fetchUnreadNotificationCount =
  async (): Promise<UnreadCountResponse> => {
    const token = getAuthTokenAsync();
    api.setHeaderAuthorization(token);
    const response: any = await api.get(
      `${process.env.REACT_APP_ADMIN_API_URL}/unread-notification-count`,
    );
    return response;
  };
